import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import DwMarker from './DwMarker';
const ContentAsset = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(DwMarker, { type: "content", uuid: props.assetid }),
        ReactHtmlParser(props.content)));
};
export default ContentAsset;
